module.exports = __webpack_public_path__ + "static/media/PodcastImage.42b0f856.png";